import "./Newsletter.module.css";
import Header from "@/reusable_sections/Header";
import Deliverables from "./sections/Deliverables";
import Subscribe from "./sections/Subscribe";
import Preferences from "./sections/Preferences";
import Footer from "@/reusable_sections/Footer";
export default function NewsletterPage() {
  return <div>
      <Header />
      <Deliverables />
      <Subscribe />
      <Preferences />
      <Footer />
    </div>;
}